module.exports = __webpack_public_path__ + "static/media/Azure.44110412.png";